import { motion } from "framer-motion";
import { Check, MessageCircle } from "lucide-react";
import { PLANS, waLink } from "@/lib/gymData";

const PERKS = ["Full gym access", "Guided workout plan", "Trainer support"];

export const Pricing = () => {
  const plans = PLANS;

  return (
    <section id="plans" data-testid="pricing-section" className="relative bg-obsidian py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="mb-14 max-w-2xl">
          <p className="text-blaze text-xs uppercase tracking-[0.3em] mb-4">Membership Plans</p>
          <h2 className="font-display text-white text-5xl sm:text-6xl xl:text-7xl leading-[0.9] tracking-tight">
            CHOOSE YOUR PLAN
          </h2>
          <p className="mt-4 text-neutral-400 text-sm tracking-wide">
            Simple, transparent pricing. No hidden charges. Cancel anytime.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {plans.map((p, i) => (
            <motion.div
              key={p.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              data-testid={`plan-${p.name.toLowerCase().replace(/\s/g, "-")}`}
              className={`relative flex flex-col p-8 rounded-sm border ${
                p.featured
                  ? "border-blaze bg-gradient-to-b from-blaze/10 to-transparent"
                  : "border-white/10 bg-[#111]"
              }`}
            >
              {p.featured && (
                <span className="absolute -top-3 left-8 bg-blaze text-white text-[10px] uppercase tracking-[0.2em] font-semibold px-3 py-1 rounded-sm">
                  {p.tag}
                </span>
              )}
              {!p.featured && (
                <span className="text-neutral-400 text-[10px] uppercase tracking-[0.2em]">{p.tag}</span>
              )}

              <h3 className="font-display text-white text-3xl tracking-tight mt-2">{p.name}</h3>

              <div className="mt-4 flex items-end gap-1">
                <span className="text-blaze font-display text-2xl leading-none mb-1">₹</span>
                <span className="font-display text-white text-6xl leading-none tracking-tight">{p.price}</span>
              </div>
              <span className="text-neutral-500 text-xs uppercase tracking-[0.15em] mt-1">{p.period}</span>

              <ul className="mt-6 space-y-3 flex-1">
                {PERKS.map((perk) => (
                  <li key={perk} className="flex items-center gap-2 text-neutral-300 text-sm">
                    <Check size={16} className="text-blaze shrink-0" /> {perk}
                  </li>
                ))}
              </ul>

              <a
                href={waLink(`Hi! I'm interested in the ${p.name} plan (₹${p.price}) at Fitness Point Gym.`)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`plan-join-${p.name.toLowerCase().replace(/\s/g, "-")}`}
                className={`mt-8 inline-flex items-center justify-center gap-2 uppercase tracking-[0.15em] font-semibold text-xs px-5 py-3.5 rounded-sm transition-colors ${
                  p.featured
                    ? "bg-blaze hover:bg-blaze-hover text-black"
                    : "border border-white/20 text-white hover:border-blaze hover:text-blaze"
                }`}
              >
                <MessageCircle size={15} /> Join Now
              </a>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
